import React, { useState } from 'react';
import MenuLayout from '../../../layouts/MenuLayout';
import BootCampLayout from '../../../layouts/BootCampLayout';
import ContactUs from './ContactUs';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../../components/loader';

const ContactUsPage = () => {
    const { state } = useLocation();
    const { isLoading } = useSelector((state) => state?.coach?.auth);
    const [isModalOpen, setIsModalOpen] = useState(false);


    const user = { name: "Contact Us", role: "coach" };

    if (isLoading) {
        return <Loader />;
    };
    return (
        <>
            {state?.data === "landing" ? (
                <MenuLayout user={user}>
                    <ContactUs data={state?.data}
                        setIsModalOpen={setIsModalOpen}
                        isModalOpen={isModalOpen}
                    />
                </MenuLayout>
            ) : (
                <BootCampLayout user={user}>
                    <ContactUs
                        data=""
                        setIsModalOpen={setIsModalOpen}
                        isModalOpen={isModalOpen}
                    />
                </BootCampLayout>
            )}
        </>
    )
};

export default ContactUsPage;